import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Tooltip} from 'antd'
import {TeamOutlined, LockOutlined, UnlockOutlined, EditOutlined, RobotOutlined } from '@ant-design/icons'
import RoleFormModal from './RoleFormModal'
import FormModal from './FormModal'
import ClawBotModal from './ClawBotModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
@inject('userManagementStore', 'roleManagementStore')
@observer
class SearchResult extends Component {
  state = {
    roleModalVisible: false,
    addModalVisible: false,
    clawBotModalVisible: false,
    record: null
  }

  componentDidMount() {
    const {userManagementStore, roleManagementStore} = this.props
    userManagementStore.onChangeUserList([])
    userManagementStore.onChangePageNo()
    userManagementStore.onSearchUserAction({
      roleId: '',
      status: '',
      searchText: '',
    }, 1, PAGE_SIZE_DEFAULT)
    roleManagementStore.onSearchRoleAction({
      roleId: '',
      status: '',
      searchText: '',
    }, 1, 99999999)
  }

  handleRole = (record) => {
    const {userManagementStore} = this.props
    userManagementStore.getRoleAction()
    var targetKeys = record.roles.map(item => item.id)
    userManagementStore.getRoleUserTargetKeys(targetKeys)
    this.setState({
      roleModalVisible: true,
      record: record
    })
  }
  handleCancelRole = () => {
    const {userManagementStore} = this.props
    userManagementStore.getRoleUserTargetKeys([])
    userManagementStore.emptyUserRoleList([])
    this.setState({
      roleModalVisible: false
    })
  }
  handleStatus = (record) => {
    const {userManagementStore} = this.props
    userManagementStore.onChangeStatus({...record, status: record.status ? false : true}, record.id)
  }
  handlePassword = (record) => {
    this.setState({
      addModalVisible: true,
      record: record
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleClawBot = record => this.setState({clawBotModalVisible: true, record})
  handleCancelClawBot = () => this.setState({clawBotModalVisible: false})
  handlePageChange = (page, pageSize) => {
    const {userManagementStore} = this.props
    userManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {userManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, userList} = userManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(userList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column width={80} title={t(`userManagement.status`)} dataIndex="statusName" key="statusName" render={(text, record, index) =>
            <div style={{
              display: 'inline-block',
              height: 24,
              width: 24,
              lineHeight: '24px',
              fontSize: 12,
              borderRadius: 24,
              color: 'white',
              textAlign: 'center',
              background: text === 'Enable' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Disable' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0'
            }}
                 title={text}>{text.charAt(0)}</div>
          }/>
          <Table.Column width={80} title={t(`userManagement.id`)} dataIndex="id" key="id"/>
          <Table.Column title={t(`userManagement.user`)} dataIndex="shortName" key="shortName" ellipsis={true}/>
          {/*<Table.Column title='Email' dataIndex="email" key="email" />*/}
          <Table.Column title={t(`userManagement.rolesList`)} dataIndex="rolesList" key="rolesList" ellipsis={true} render={rolesList => (
            <Tooltip placement="topLeft" title={rolesList}>
              {rolesList}
            </Tooltip>
          )}/>
          <Table.Column title={t(`userManagement.email`)} dataIndex="email" key="email"/>
          <Table.Column title={t(`userManagement.phone`)} dataIndex="phone" key="phone"/>
          <Table.Column title={t(`userManagement.superAdmin`)} dataIndex="powerUser" key="powerUser"/>
          <Table.Column width={190} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button onClick={() => this.handleRole(record)} type="link" disabled={record.status === false} icon={<TeamOutlined/>}
                      title={t(`userManagement.role`)}/>
              <Button onClick={() => this.handleStatus(record)} type="link" icon={record.status === false ? <LockOutlined/> : <UnlockOutlined/>}
                      title={record.status === false ? t(`general.enable`) : t(`general.disable`)}/>
              <Button onClick={() => this.handlePassword(record)} type="link" icon={<EditOutlined />}
                      title={t(`userManagement.password`)}/>
              <Button onClick={() => this.handleClawBot(record)} type="link" icon={<RobotOutlined />}
                      title={t(`userManagement.clawbot`)}/>
            </>
          )}/>
        </Table>
        {this.state.roleModalVisible ? <RoleFormModal
          roleModalVisible={this.state.roleModalVisible}
          fieldsValue={this.state.fieldsValue}
          handleCancelRole={this.handleCancelRole}
          record={this.state.record}
        /> : null}
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          record={this.state.record}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.clawBotModalVisible ? <ClawBotModal
          record={this.state.record}
          onClose={this.handleCancelClawBot}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
